<template>
  <div
    :key="rerenderKey"
    style="
      position: absolute;
      cursor: grab;
      perspective: 10;
    "
    :style="{
      top: `${settings.yPos}px`,
      left: `${settings.xPos}px`,
    }"
    @mousedown.stop="onDragMouse"
    @touchstart.stop="onDragTouch"
    @mouseup="onDropMouse"
    @touchend="onDropTouch"
    @mousemove="onMoveMouse"
    @touchmove="onMoveTouch"
    @mouseenter="() => { isHovering = true; }"
    @mouseleave="() => { isHovering = false; }"
  >
    <img
      :src="resolveAssetPath(settings.image, 'ui/customer')"
      style="
        position: absolute;
        top: 0;
        left: 0;
        object-fit: contain;
      "
      :style="{
        width: (settings.scale && settings.scale > 0) ? `${settings.scale}px` : undefined,
        'z-index': (isDragging ? 902 : 900),
        outline: (errorOutline ? '2px solid red' : undefined),
      }"
      @load="onLoadImage"
    >
    <!-- <div
      style="
        position: absolute;
        top: 0;
        left: 0;
        width: 10px;
        height: 10px;
        z-index: 1000;
        background-color: black;
      "
    ></div> -->
    <!-- trick to not lose drags if user drags faster than the browser refresh rate can keep up with -->
    <div
      v-if="isDragging"
      style="
        position: absolute;
        top: -5000px;
        left: -5000px;
        width: 10000px;
        height: 10000px;
      "
      :style="{
        'z-index': (isDragging ? 902 : 900),
      }"
    ></div>
    <!-- label -->
    <div
      v-if="!!(settings.hoverText) && (isDragging || isHovering)"
      style="
        pointer-events: none;
        user-select: none;
        position: absolute;
        bottom: 100%;
        display: flex;
        flex-flow: row nowrap;
        justify-content: center;
        align-items: center;
        transform-style: preserve-3d;
        transform: translateZ(2px);
      "
      :style="{
        width: (settings.scale && settings.scale > 0) ? `${settings.scale}px` : undefined,
        'z-index': 905,
      }"
    >
      <div
        style="
          border-radius: 8px;
          padding: 4px 8px;
          font-size: 1.1rem;
        "
        :style="{
          'background-color': settings.hoverTextBackgroundColor || 'black',
          color: settings.hoverTextColor || 'white',
        }"
        v-html="settings.hoverText"
      ></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import isInIframe from '../../../utils/iframe';

export default {
  props: {
    /** expects `image`, `xPos`, `yPos`, `scale`, `hoverText` */
    settings: { type: Object },
    scaleFactor: { type: Number },
    errorOutline: { type: Boolean },
  },
  data() {
    return {
      dragOffsetX: 0,
      dragOffsetY: 0,
      isDragging: false,
      rerenderKey: 0,
      isHovering: false,
    };
  },
  computed: {
    ...mapGetters([
      'disableForcedLandscape',
    ]),
  },
  methods: {
    isFakeLandscape() {
      const { clientWidth, clientHeight } = document.documentElement;
      return !(this.disableForcedLandscape || isInIframe()) && clientWidth < 767 && clientHeight > clientWidth;
    },
    onDragMouse(ev) {
      this.isDragging = true;
      if (this.isFakeLandscape()) {
        this.dragOffsetX = (ev.screenY / this.scaleFactor) + +this.settings.xPos;
        this.dragOffsetY = (ev.screenX / this.scaleFactor) - +this.settings.yPos;
      } else {
        this.dragOffsetX = (ev.screenX / this.scaleFactor) - +this.settings.xPos;
        this.dragOffsetY = (ev.screenY / this.scaleFactor) - +this.settings.yPos;
      }
      this.$emit('drag-start', this.settings);
    },
    onDragTouch(ev) {
      ev.stopPropagation();
      if (ev.touches.length !== 1) return;
      this.isDragging = true;
      if (this.isFakeLandscape()) {
        this.dragOffsetX = (ev.touches[0].screenY / this.scaleFactor) + +this.settings.xPos;
        this.dragOffsetY = (ev.touches[0].screenX / this.scaleFactor) - +this.settings.yPos;
      } else {
        this.dragOffsetX = (ev.touches[0].screenX / this.scaleFactor) - +this.settings.xPos;
        this.dragOffsetY = (ev.touches[0].screenY / this.scaleFactor) - +this.settings.yPos;
      }
      this.$emit('drag-start', this.settings);
    },
    onDrop() {
      this.isDragging = false;
      this.isHovering = false; // needed for touch interfaces
      this.dragOffsetX = 0;
      this.dragOffsetY = 0;
      this.$emit('drag-end', this.settings);
    },
    onDropMouse() {
      this.onDrop();
    },
    onDropTouch() {
      this.onDrop();
    },
    onMoveMouse(ev) {
      if (this.isDragging) {
        if (this.isFakeLandscape()) {
          this.settings.xPos = Math.round(this.dragOffsetX - (ev.screenY / this.scaleFactor));
          this.settings.yPos = Math.round((ev.screenX / this.scaleFactor) - this.dragOffsetY);
        } else {
          this.settings.xPos = Math.round((ev.screenX / this.scaleFactor) - this.dragOffsetX);
          this.settings.yPos = Math.round((ev.screenY / this.scaleFactor) - this.dragOffsetY);
        }
        this.$emit('drag-move', this.settings);
        this.rerenderKey = (this.rerenderKey + 1) % 100;
      }
    },
    onMoveTouch(ev) {
      if (this.isDragging) {
        ev.stopPropagation();
        if (ev.touches.length !== 1) return;
        if (this.isFakeLandscape()) {
          this.settings.xPos = Math.round(this.dragOffsetX - (ev.touches[0].screenY / this.scaleFactor));
          this.settings.yPos = Math.round((ev.touches[0].screenX / this.scaleFactor) - this.dragOffsetY);
        } else {
          this.settings.xPos = Math.round((ev.touches[0].screenX / this.scaleFactor) - this.dragOffsetX);
          this.settings.yPos = Math.round((ev.touches[0].screenY / this.scaleFactor) - this.dragOffsetY);
        }
        this.$emit('drag-move', this.settings);
        this.rerenderKey = (this.rerenderKey + 1) % 100;
      }
    },
    onLoadImage(ev) {
      this.$emit('loaded-img', ev);
    }
  },
  watch: {
    settings: {
      handler() {
        this.rerenderKey = (this.rerenderKey + 1) % 100;
      },
      deep: true
    },
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/game/ui/DraggableImage.vue